export default __webpack_public_path__ + "static/media/IMG_0564.5def39dc.jpg";